import { FC, Fragment, useEffect, useRef, useState } from "react";
import { Col, Collapse, Row } from "antd";
import { CheckCircleFilled, CheckCircleOutlined } from "@ant-design/icons";
import { cloneDeep } from "lodash";
import moment from "moment";
import classNames from "classnames";
import { appInsights, reactPlugin, withAITracking } from "../../../../appInsights";

import CustomTooltip from "@pages/tool-tip";
import PinUnpin from "../../pin-unpin-component";
import ModalCustom from "@components/modal-custom";
import { formatDisplayDate } from "@utils/helpers";
import GenericOptionDisplayFormat from "./generic-options-display-format/generic-options-display-format";
import memberDetailsService from "@services/memberDetails.service";
import membersService from "@services/members.service";

import { useAlternativeGenericMedicationStore } from "@stores/useAlternativeGenericMedicationStore";

import "./alternativegenericmedication.scss";
import { useGlobalInformationStore } from "@stores/global_informationStore";
import { CanEdit } from '@components/accessLevel'
import DataNotFound from "@components/noDataFound";
import { NO_DATA_FOUND } from "../../../../constants/constants";

export interface IDataItem {
  medicationName: string;
  genericDrugBrand: string | null;
  genericDrugName: string;
  isGenericOptionAvailable: boolean | string;
  lastRefillDate: string;
  nextRefillDate: string;
  quantity: number;
  status: string;
  acceptedOn: string;
  rejectedOn: string;
  genericMedications: any[];
  ndcNumber: any;
}

interface IAlternativeGenericMedication {
  data: IDataItem[];
  pinChangeHandler: any;
  pinCardIds: any;
  setActiveTabKey: any;
  activeKey: any;
  alternativegenericmedicationDataPinCardID: any;
  loadingForActionable?: any;
  setActivePanels: any;
}

enum RadioValidStates {
  Accepted = "A",
  Rejected = "R",
  AcceptedFalse = "F",
  Neutral = "null",
}

const AlternativeGenericMedication: FC<IAlternativeGenericMedication> = ({ data, pinChangeHandler,loadingForActionable, pinCardIds, activeKey, setActivePanels, setActiveTabKey, alternativegenericmedicationDataPinCardID }) => {
  const [newDataState, setNewDataState] = useState<IDataItem[]>([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [modalConfirmationText, setModalConfirmationText] = useState("");
  const [currentNewRadioState, setCurrentNewRadioState] = useState("");
  const [userClickedOnAccOrRej, setuserClickedOnAccOrRej] = useState("");
  const [loading, setLoading] = useState(false);
  const [confirmationModalTitle, setConfirmationModalTitle] = useState<string>("");
  const [currentOpenModalIndex, setCurrentOpenModalIndex] = useState<number>();

  const currentSelectedIndex = useRef<number>(-1);
  const currentSelectedCol = useRef<string>("");
  const dataState = useAlternativeGenericMedicationStore((state) => state.dataState);
  const setDataState = useAlternativeGenericMedicationStore((state) => state.setDataState);
  const dataCardId = "35";
  const [activeCardPanel, setActiveCardPanel] = useState<any>(activeKey?.includes(dataCardId) ? ["1"] : [])
 

  const { Panel } = Collapse;
  const cMember = membersService?.getCurrentMember;

  const autoScroll = useGlobalInformationStore((state) => state.autoScroll);
  const setAutoSroll = useGlobalInformationStore((state) => state.setAutoSroll);
  const isModalOpenToResetTheStatus =  useRef(false);

  useEffect(() => {
    console.log("AlternativeGenericMedication.useEffect1");
    if(autoScroll === true && loadingForActionable === false) { 
      setTimeout(() => window.scrollTo({left: 0,top: document.body.scrollHeight , behavior: 'smooth'}), 500);
      window.scrollTo(0, document.body.scrollHeight);setAutoSroll(false)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [autoScroll , loadingForActionable]);

  useEffect(() => {
    console.log("AlternativeGenericMedication.useEffect2");
    setActiveCardPanel(activeKey?.includes(dataCardId) ? ["1"] : []);
  }, [activeKey])

  const onCollapseChange = () => {
    if(activeCardPanel.length > 0){
      setActivePanels(cloneDeep(activeKey)?.filter((item:any) => item !== dataCardId))
    }
    else setActivePanels([...(activeKey ? activeKey : []), dataCardId]);
  }

  useEffect(() => {
    console.log("AlternativeGenericMedication.useEffect3");
    const markSelected = cloneDeep(data);
    markSelected?.forEach((d) => {
      let tempGmArr: any = [];
      d.genericMedications.forEach((gm) => {
        if (d.genericDrugBrand === gm.genericBrand && d.genericDrugName === gm.genericDrugName) {
          gm["selected"] = true;
          tempGmArr.unshift(gm);
        } else {
          gm["selected"] = false;
          tempGmArr.push(gm);
        }
      });
      d.genericMedications = tempGmArr;
    });
    setDataState(markSelected);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  const getAlternateMedicationData = () => {
    return memberDetailsService.getAlternateMedication(parseInt(cMember?.patient_id)).subscribe({
      next: (v: any) => {
        const markSelected: IDataItem[] = cloneDeep(v.data.data.medications.values);
        markSelected?.forEach((dataItem) => {
          let tempGmArr: any = [];
          dataItem.genericMedications.forEach((gm) => {
            if (dataItem.genericDrugBrand === gm.genericBrand && dataItem.genericDrugName === gm.genericDrugName) {
              gm["selected"] = true;
              tempGmArr.unshift(gm);
            } else {
              gm["selected"] = false;
              tempGmArr.push(gm);
            }
          });
          dataItem.genericMedications = tempGmArr;
        });
        setDataState(markSelected);
      },
      error: (e) => {
        console.log(e);
        setLoading(false);
      },
    });
  };

  const getHeading = () => {
    return (
      <div className="alternative-generic-medication-heading">
        <div>Alternative Generic Medication</div>
        <div>
          <CustomTooltip
            toolTipvalue={"This widget gives Generic Alternative to the brand medications that the patient is availing"}
            children={<span className="icon icon-info clr-lightGrayColor m--8"></span>}
          />
        </div>
      </div>
    );
  };

  const getExtraEle = (id: any) => {
    return (
      <div className="center-align-content">
        <div className="center-align-content claims-history-btn mr--20">
          <div
            onClick={() => {
              setActiveTabKey("11");
            }}
            className="f16 fw500 blue-color"
          >
            Claims History
          </div>
          <div
            onClick={() => {
              // navigate to Medical History tab.
              setActiveTabKey("11");
            }}
          >
            <i className={"icon-arrow-circle-right center-align-content center-align-content--x_center blue-color ml--8"} />
          </div>
        </div>
        <div className="mr--16">
          <PinUnpin dataCardId={id} changeHandler={pinChangeHandler} pinCardIds={pinCardIds} />
        </div>
      </div>
    );
  };

  function formatModalConfirmationText(colAccRej: string, index: number): void {
    let acceptedOrRejectedText = "";
    let dsiplayDate = "";
    setConfirmationModalTitle("Are you sure?");
    if (dataState[index].status === RadioValidStates.Accepted) {
      acceptedOrRejectedText = "Accepted on ";
      dsiplayDate = formatDisplayDate(dataState[index].rejectedOn, "createDateFormat", "defaultDateFormat");
    } else if (dataState[index].status === RadioValidStates.Rejected) {
      acceptedOrRejectedText = "Rejected on ";
      dsiplayDate = formatDisplayDate(dataState[index].acceptedOn, "createDateFormat", "defaultDateFormat");
    }

    let warningText = "";
    isModalOpenToResetTheStatus.current = false;

    if (colAccRej === "rejectedCol" && dataState[index].status === RadioValidStates.Accepted) {
      warningText = "Do you want to reject it?";
    }

    if (colAccRej === "rejectedCol" && dataState[index].status === "null") {
      warningText = "Do you want to reject it?";
    }

    if (colAccRej === "rejectedCol" && dataState[index].status === RadioValidStates.AcceptedFalse) {
      warningText = "Patient has refilled brand medication after accepting generic option";
    }

    if (colAccRej === "acceptedCol" && dataState[index].status === RadioValidStates.Rejected) {
      warningText = "Do you want to accept it?";
    }

    if (colAccRej === "acceptedCol" && dataState[index].status === "null") {
      warningText = "Do you want to accept it?";
    }

    if (colAccRej === "acceptedCol" && dataState[index].status === RadioValidStates.AcceptedFalse) {
      setConfirmationModalTitle("Status can't be changed");
      warningText = `Please choose another generic option to reset \n or \n Reject this generic option`;
    }

    if ((colAccRej === "acceptedCol" && dataState[index].status === RadioValidStates.Accepted) || (colAccRej === "rejectedCol" && dataState[index].status === RadioValidStates.Rejected)) {
      warningText = ", are you sure you want to reset status?";
      isModalOpenToResetTheStatus.current = true;
    }

    setModalConfirmationText(acceptedOrRejectedText + dsiplayDate + "  " + warningText);
  }

  const setCheckedUncheckedState = (colAccRej: string, index: number, newState: string) => {
    setCurrentNewRadioState(newState);
    setuserClickedOnAccOrRej(colAccRej);

    const selectedGenericMedications = dataState[index].genericMedications.find((data) => {
      return data.selected === true;
    });

    let tempNewDataState: IDataItem[] = cloneDeep(dataState);
    tempNewDataState[index].status = newState;

    if (dataState[index].status === null || dataState[index].status === "null" || dataState[index].status === "") {
      // if radio status is empty select option without  showing warning modal.
      updateStatus(newState, selectedGenericMedications);
      setDataState(tempNewDataState);
    } else {
      formatModalConfirmationText(colAccRej, index);
      // show warning modal
      setIsModalVisible(true);

      if (colAccRej === "acceptedCol") {
        tempNewDataState[index].acceptedOn = moment(new Date()).format("YYYY-MM-DD");
      } else {
        tempNewDataState[index].rejectedOn = moment(new Date()).format("YYYY-MM-DD");
      }
      // temporary state merging this state on the modal confirmation only.
      setNewDataState(tempNewDataState);
    }
  };

  const updateStatus = (newState: string, selectedGenericMedications: any) => {
    let isAccepted: any = false;
    let isRejected: any = false;

    if (newState === RadioValidStates.Accepted) {
      isAccepted = true;
      isRejected = null;
    }

    if (newState === RadioValidStates.Rejected) {
      isAccepted = null;
      isRejected = true;
    }

    if (newState === RadioValidStates.Neutral || newState === "" || newState === "null") {
      isAccepted = null;
      isRejected = null;
    }

    if (cMember && cMember?.patient_id) {
      setLoading(true);
      memberDetailsService
        .updateAlternateMedication(
          cMember.patient_id,
          dataState[currentSelectedIndex.current]?.medicationName,
          selectedGenericMedications.genericDrugName,
          selectedGenericMedications.genericBrand,
          isAccepted,
          isRejected,
          true,
          dataState[currentSelectedIndex.current]?.ndcNumber,
        )
        .subscribe({
          next: (v: any) => {
            getAlternateMedicationData();
            setLoading(false);
          },
          error: (e) => {
            console.log(e);
            setLoading(false);
          },
        });
    }
  };

  const handleOnOk = () => {
    if (!(currentNewRadioState === RadioValidStates.AcceptedFalse && userClickedOnAccOrRej === "acceptedCol")) {
      const selectedgenericMedication = newDataState[currentSelectedIndex.current]?.genericMedications.find((d) => {
        return d.selected === true;
      });
      updateStatus(currentNewRadioState, selectedgenericMedication);
      setDataState(newDataState);
    }
    setIsModalVisible(false);
  };

  const getCircleForEmptyStatus = (colAccRej: string, tooltipValue: string, index: number, newState: string) => {
    return (
      <div>
        <CustomTooltip
          toolTipvalue={tooltipValue}
          children={
            <div
              className={classNames({
                "cursor-not-allowed": dataState[index].isGenericOptionAvailable === "false" || dataState[index].genericDrugBrand === "" || dataState[index].genericDrugBrand === null,
              })}
            >
              <CheckCircleOutlined
                className={classNames({
                  "medication-status-not-selected": true,
                  "pointer-event-none": dataState[index].isGenericOptionAvailable === "false" || dataState[index].genericDrugBrand === "" || dataState[index].genericDrugBrand === null,
                })}
                onClick={() => {
                  currentSelectedIndex.current = index;
                  currentSelectedCol.current = colAccRej;
                  setCheckedUncheckedState(colAccRej, index, newState);
                }}
              />
            </div>
          }
        />
      </div>
    );
  };

  const getCircleForRejected = (colAccRej: string, tooltipValue: string, index: number, newState: string) => {
    return (
      <span className="disable-click">
        <CustomTooltip
          toolTipvalue={tooltipValue}
          children={
            <div
              className={classNames({
                "cursor-not-allowed": false,
              })}
            >
              <CheckCircleFilled
                className={classNames({
                  "medication-rejected--completed_color": true,
                  "pointer-event-none": false,
                })}
                onClick={() => {
                  currentSelectedIndex.current = index;
                  currentSelectedCol.current = colAccRej;
                  setCheckedUncheckedState(colAccRej, index, newState);
                }}
              />
            </div>
          }
        />
      </span>
    );
  };

  const getCircleForAccepted = (colAccRej: string, tooltipValue: string, index: number, newState: string) => {
    return (
      <span className="disable-click">
        <CustomTooltip
          toolTipvalue={tooltipValue}
          children={
            <CheckCircleFilled
              className={classNames({
                "disable-click": dataState[index].isGenericOptionAvailable,
                "medication-accepted--completed_color": true,
              })}
              onClick={() => {
                currentSelectedIndex.current = index;
                currentSelectedCol.current = colAccRej;
                setCheckedUncheckedState(colAccRej, index, newState);
              }}
            />
          }
        />
      </span>
    );
  };

  const getCheckUncheckCircle = (colAccRej: string, index: number) => {
    let tooltipValue = "";
    if (colAccRej === "acceptedCol") {
      if (dataState[index].status === RadioValidStates.Neutral || dataState[index].status === "" || dataState[index].status === null || dataState[index].status === RadioValidStates.Rejected) {
        tooltipValue = "";
        return getCircleForEmptyStatus(colAccRej, tooltipValue, index, RadioValidStates.Accepted);
      }

      if (dataState[index].status === RadioValidStates.Accepted) {
        tooltipValue = `Accepted on: \n ${formatDisplayDate(dataState[index].acceptedOn, "createDateFormat", "defaultDateFormat")}`;
        return getCircleForAccepted(colAccRej, tooltipValue, index, "null");
      }

      if (dataState[index].status === RadioValidStates.AcceptedFalse) {
        tooltipValue = `Accepted on: ${formatDisplayDate(dataState[index].acceptedOn, "createDateFormat", "defaultDateFormat")} but \n Brand Medication was filled.`;
        return getCircleForRejected(colAccRej, tooltipValue, index, RadioValidStates.AcceptedFalse);
      }
    }

    if (colAccRej === "rejectedCol") {
      if (dataState[index].status === RadioValidStates.Neutral || dataState[index].status === "" || dataState[index].status === null || dataState[index].status === RadioValidStates.Accepted) {
        tooltipValue = "";
        return getCircleForEmptyStatus(colAccRej, tooltipValue, index, RadioValidStates.Rejected);
      }

      if (dataState[index].status === RadioValidStates.Rejected) {
        tooltipValue = `Rejected on: \n ${formatDisplayDate(dataState[index].acceptedOn, "createDateFormat", "defaultDateFormat")}`;
        return getCircleForRejected(colAccRej, tooltipValue, index, "null");
      }

      if (dataState[index].status === RadioValidStates.AcceptedFalse) {
        tooltipValue = "";
        return getCircleForEmptyStatus(colAccRej, tooltipValue, index, RadioValidStates.Rejected);
      }
    }
  };

  const getRow = () => {
    return dataState?.map((data, index) => {
      return (
        <Fragment key={index}>
          {loading && index === currentSelectedIndex.current ? (
            <Row className="mb-23">
              <Col span={6}>
                <div className="preload shimmerBG"></div>
              </Col>
              <Col span={6}>
                <div className="preload shimmerBG"></div>
              </Col>
              <Col span={3}>
                <div className="preload shimmerBG"></div>
              </Col>
              <Col span={3}>
                <div className="preload shimmerBG"></div>
              </Col>
              <Col span={2}>
                <div className="preload shimmerBG"></div>
              </Col>
              <Col span={2}>
                <div className="preload shimmerBG"></div>
              </Col>
              <Col span={2}>
                <div className="preload shimmerBG"></div>
              </Col>
            </Row>
          ) : (
            <Row className="mb--23">
              <Col className="center-align-content" span={6}>
                <CustomTooltip
                  children={
                    <div className="f16 fw400 clr-lightGrayColor medication-name">
                      {index + 1}. {data.medicationName}
                    </div>
                  }
                  toolTipvalue={data.medicationName}
                />
              </Col>
              <Col className="center-align-content" span={6} key={index}>
                <GenericOptionDisplayFormat
                  index={index}
                  setCurrentOpenModalIndex={setCurrentOpenModalIndex}
                  currentOpenModalIndex={currentOpenModalIndex}
                  currentSelectedIndex={currentSelectedIndex}
                />
              </Col>
              <Col className="f14 fw400 clr-lightGrayColor center-align-content" span={3}>
                <span>{Date.parse(data.lastRefillDate) ? formatDisplayDate(data.lastRefillDate, "createDateFormat", "defaultDateFormat") : data.lastRefillDate}</span>
              </Col>
              <Col className="f14 fw400 clr-lightGrayColor center-align-content" span={3}>
                <span>{Date.parse(data.nextRefillDate) ? formatDisplayDate(data.nextRefillDate, "createDateFormat", "defaultDateFormat") : data.nextRefillDate}</span>
              </Col>
              <Col className="f14 fw400 clr-lightGrayColor center-align-content center-align-content--x_center" span={2}>
                <span>{data.quantity}</span>
              </Col>
              <Col className="center-align-content center-align-content--x_center" span={2}>
                <CanEdit hide={false}>
                {getCheckUncheckCircle("acceptedCol", index)}
                </CanEdit>
              </Col>
              <Col className="center-align-content center-align-content--x_center" span={2}>
                <CanEdit hide={false}>
                {getCheckUncheckCircle("rejectedCol", index)}
                </CanEdit>
              </Col>
            </Row>
          )}
        </Fragment>
      );
    });
  };

  return (
    <>
      <Collapse accordion bordered={false} expandIconPosition="right" activeKey={activeCardPanel} onChange={onCollapseChange}>
        <Panel className="alternative-generic-medication-title" header={getHeading()} extra={getExtraEle(dataCardId)} key="1">
          {dataState?.length === 0 ? (
            <DataNotFound message={NO_DATA_FOUND}/>
          ) : (
            <>
              <Row className="mb--28">
                <Col span={6}></Col>
                <Col className="f12 clr-lightGrayColor" span={6}>
                  Generic Options
                </Col>
                <Col className="f12 clr-lightGrayColor" span={3}>
                  Last Refill Date
                </Col>
                <Col className="f12 clr-lightGrayColor" span={3}>
                  Next Refill Date
                </Col>
                <Col className="f12 clr-lightGrayColor center-align-content center-align-content--x_center" span={2}>
                  Quantity
                </Col>
                <Col className="f12 clr-lightGrayColor center-align-content center-align-content--x_center" span={2}>
                  Accepted
                </Col>
                <Col className="f12 clr-lightGrayColor center-align-content center-align-content--x_center" span={2}>
                  Rejected
                </Col>
              </Row>
              {getRow()}
            </>
          )}

          <ModalCustom
            title={confirmationModalTitle}
            visible={isModalVisible}
            width={500}
            onOk={() => {
              handleOnOk();
              isModalOpenToResetTheStatus.current = false;
            }}
            setVisible={setIsModalVisible}
            zIndex={2}
            text={modalConfirmationText}
            preLine={true}
            showCloseBtn={currentSelectedCol.current === "acceptedCol" && dataState[currentSelectedIndex.current]?.status === RadioValidStates.AcceptedFalse ? false : true}
            customTextStyle={isModalOpenToResetTheStatus.current ? {display: "block", paddingLeft: "20%", paddingRight: "20%"} : {}}
            okText={isModalOpenToResetTheStatus.current ? "Reset Status" : ""}
            cancelText={"Cancel"}
            customCancelButtonStyle={{ color: "#7A869A", boxShadow: "none", borderColor: "#7A869A", backgroundColor: "#FFFFFF" }}
            customOkButtonStyle={isModalOpenToResetTheStatus.current ? { width: "162px" } : {}}
          />
        </Panel>
      </Collapse>
    </>
  );
};

export default withAITracking(reactPlugin, AlternativeGenericMedication);
